// src/components/routes/FranquiciadoRegisterWrapper.jsx
// Wrapper para renderizar el registro de franquiciado personalizado o el general
import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import FranquiciadoRegister from '../../pages/auth/FranquiciadoRegister';
import FranquiciadoRegisterCustom from '../../templates/empanadaclub/pages/auth/FranquiciadoRegister';
import { CUSTOM_TEMPLATE_MARCA_ID } from '../../utils/customTemplateHelper';

const FranquiciadoRegisterWrapper = () => {
    const [searchParams] = useSearchParams();
    const [useCustomTemplate, setUseCustomTemplate] = useState(false);
    const [loading, setLoading] = useState(true);
    const tiendaId = searchParams.get('tiendaId');

    useEffect(() => {
        const checkMarca = async () => {
            if (!tiendaId) {
                setLoading(false);
                return;
            }

            try {
                // Obtener la tienda usando el endpoint público (no requiere autenticación)
                const tienda = await get(`tiendas/public/${tiendaId}`);

                // Extraer el marcaId (puede ser un objeto o un ID)
                const marcaId = tienda.marca?._id || tienda.marca;

                // Verificar si la marca coincide con la marca personalizada
                if (marcaId === CUSTOM_TEMPLATE_MARCA_ID) {
                    setUseCustomTemplate(true);
                }
            } catch (error) {
                console.error('Error checking marca for franquiciado register:', error);
                // Si falla, usar el registro general por defecto
            } finally {
                setLoading(false);
            }
        };

        checkMarca();
    }, [tiendaId]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-600">Cargando...</p>
                </div>
            </div>
        );
    }

    // Si no hay tiendaId, mostrar el registro general
    if (!tiendaId) {
        return <FranquiciadoRegister />;
    }

    // Renderizar el componente correspondiente
    return useCustomTemplate ? <FranquiciadoRegisterCustom /> : <FranquiciadoRegister />;
};

export default FranquiciadoRegisterWrapper;

